import { api } from "@king-ict/eupisi-ui/utils";

const documentsUrlPrefix: string = "documents";

export const getUserManual = async () => {
  return api.download(`${documentsUrlPrefix}/user-manual`) as Promise<any>;
};